import { SPECS_PRODUCT_TYPES } from './constants'

export const isValidSpecsProductType = productType =>
  Object.values(SPECS_PRODUCT_TYPES).includes(productType)
